import { Box, Chip, Typography} from "@mui/material";
import Header from "../../components/Header";
import swal from "sweetalert";
import axios from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Row from "./skoolTable.jsx";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import VerifiedIcon from "@mui/icons-material/Verified";

function Skool() {
    const [tableValues, setTableValues] = useState([]);
    const navigate = useNavigate();
  
    async function deleteTableRow(community, index){
      swal(
        "Are you sure!",
        `Do you want to delete your token gating configuration for community: ${community}`,
        "warning",
        {
          buttons: ["Cancel", "OK"],
        }
      ).then(async (value) => {
        if (value) {
          await axios
            .delete(
              `${process.env.REACT_APP_BASE_URL}/skool-user-info`,
              {
                headers: {
                  "content-type": "application/json",
                  token: localStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              if (response.data.status === true) {
                let newTableValues = [...tableValues];
                newTableValues.splice(index, 1);
                setTableValues(newTableValues);
                swal(
                  "Deleted!",
                  `Your token gating configuration for community: ${community} is successfully deleted.`,
                  "success",
                  {
                    button: "OK",
                  }
                );
              } else {
                swal("Something went wrong!", ``, "error", {
                  button: "OK",
                });
              }
            })
            .catch((err) => {
              swal({
                text: err.response.data.errorMessage,
                icon: "error",
                // type: "error"
              });
            });
        }
      });
    }

    async function getSkoolTokenGatingInfo(){
      try{
        await axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/skool/get-token-gating-configuration`,
        {
          headers: {
            "content-type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        if(response.data.status){
          setTableValues(response.data.tokenGatingTable);
        }
      })
      .catch((err) => {
        swal({
          title: "Something Went Wrong!",
          icon: "error",
          button: "OK",
        });
      });

      }catch(e){
      
      }

    }

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

    async function editTableRow(row) {
      navigate("/token-gating/skool/configuration", {
        state: row.tokenGatingDetails ,
      });
    }

    useEffect(()=>{
      getSkoolTokenGatingInfo()
    }, [])

  return (
    <Box m="20px">
        <div >
          <Header
            title="Skool Token Gating"
              subtitle="Configure NFT token gating for your skool community"
          />
        </div>
       
        <div
          style={{
            marginTop: "50px",
          }}
        >
          <div >
          {!tableValues.length && <Button
            className="custom-color-button"
            color="info"
            sx={{
              backgroundColor: "#6870fa",
              float: "right",
              marginTop: "4px",
              fontSize: "15px",
            }}
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              navigate("/token-gating/skool/configuration");
            }}
          >
            Add Configuration
          </Button>}
          </div>
          <Typography color="red" fontSize="18" sx={{paddingTop:"10px"}}>
            Note : Please copy and paste the below link in the Links section in your Skool Community
          </Typography>
          <Box minHeight="40vh" sx={{marginTop:"25px"}}>
            <Paper sx={{ width: "100%", boxShadow: 4 }}>
              <TableContainer>
                <Table aria-label="collapsible table">
                  <TableHead>
                    <TableRow>
                      <TableCell className="tableHead" />
                      <TableCell
                        className="tableHead"
                        sx={{ textAlign: "left !important" }}
                      >
                        Community Name
                      </TableCell>
                      <TableCell className="tableHead" align="center">
                        Link
                      </TableCell>
                      <TableCell className="tableHead" align="center">
                        Edit
                      </TableCell>
                      <TableCell className="tableHead" align="center">
                        Delete
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableValues
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <Row
                          deleteTableRow={deleteTableRow}
                          editTableRow={editTableRow}
                          key={row.communityName}
                          index={index}
                          row={row}
                        />
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={tableValues.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Box>
        </div>
      </Box>
  );
}

export default Skool;
